<div class="outer-wrapper">
	<div class="title">{{ title }}</div>
	<div class="container">
		<div class="nav" #navContainer (keydown)="onNavKeydown($event, navContainer)">
			<div *ngFor="let step of config.steps; let i = index">
				<app-wizard-step
					[step]="i"
					[label]="step.label"
					[isCurrentStep]="i === currentStep"
					(clicked)="setCurrentStep(i)"
				></app-wizard-step>

				<div
					class="connector"
					*ngIf="i !== config.steps.length - 1"
				></div>
			</div>
		</div>

		<div class="content">
			<div
				class="has-error"
				*ngIf="hasError"
			>
				Service Error.
			</div>
			<div
				class="component"
				[ngClass]="{
					hidden: hasError
				}"
			>
				<ng-template #placeholder></ng-template>
			</div>
			<div class="buttons">
				<app-action-button
					[disabled]="currentStep === 0"
					(buttonClicked)="onPrev()"
					title="<<"
					[customStyle]="buttonStyle"
				></app-action-button>
				<app-confirm-action-btn
					*ngIf="false"
					(confirmed)="onReset()"
					btnLabel="Reset"
					[disabled]="config.steps[currentStep].noResetBtn"
					[customStyle]="buttonStyle"
				></app-confirm-action-btn>

				<app-confirm-action-btn
					(confirmed)="onCancel()"
					btnLabel="Cancel"
					[customStyle]="buttonStyle"
				></app-confirm-action-btn>
				<app-action-button
					(buttonClicked)="onSave()"
					[disabled]="currentStep < config.steps.length - 1 || disableSaveButton"
					title="Save"
					[matTooltip]="
						currentStep === config.steps.length - 1 && disableSaveButton
							? 'Missing input for required fields'
							: ''
					"
					[customStyle]="buttonStyle"
				></app-action-button>
				<app-action-button
					[disabled]="currentStep === config.steps.length - 1 || disableNextButton"
					(buttonClicked)="onNext()"
					title=">>"
					[customStyle]="buttonStyle"
				></app-action-button>
			</div>
		</div>
	</div>
</div>
